export const DD_MM_YYYY_FORMAT = {
    parse: {
        dateInput: 'dd-MM-yyyy',
    },
    display: {
        dateInput: 'dd-MM-yyyy',
        monthYearLabel: 'MMM yyyy',
        dateA11yLabel: 'dd-MM-yyyy',
        monthYearA11yLabel: 'MMMM yyyy',
    },
};


